/*
  Admin API client. All requests include credentials so the httpOnly
  vh_admin_token cookie is sent.
*/
import axios from "axios";
import { API } from "./api";

const http = axios.create({ baseURL: `${API}/admin`, withCredentials: true });

function formatDetail(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map(x => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Request failed";
}

export const adminApi = {
  async me() { return (await http.get("/me")).data; },
  async login(email, password) {
    try { return (await http.post("/login", { email, password })).data; }
    catch (e) { throw new Error(formatDetail(e)); }
  },
  async logout() { return (await http.post("/logout")).data; },
  async getConfig() { return (await http.get("/config")).data; },
  async updateConfig(patch) {
    try { return (await http.put("/config", patch)).data; }
    catch (e) { throw new Error(formatDetail(e)); }
  },
  async stats() { return (await http.get("/stats")).data; },
  async uploadLogo(file) {
    const fd = new FormData();
    fd.append("file", file);
    try {
      return (await http.post("/assets/logo", fd, { headers: { "Content-Type": "multipart/form-data" } })).data;
    } catch (e) { throw new Error(formatDetail(e)); }
  },
  async resetLogo() { return (await http.delete("/assets/logo")).data; },
};
